import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: "app-image-with-loading",
  templateUrl: "./image-with-loading.component.html",
  styleUrls: ["./image-with-loading.component.scss"]
})
export class ImageWithLoadingComponent implements OnInit {
  @Input() loader: string =
    "./assets/img/logo4.gif";
  @Input() height: number = 100;
  @Input() width: number = 100;
  @Input() heightloader: number = 100;
  @Input() widthloader: number = 100;
  @Input() image: string;

  isLoading: boolean;

  constructor() {
    this.isLoading = true;
  }
  ngOnInit() { }

  hideLoader() {
    this.isLoading = false;
  }
}
